import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "../../../Employee/EmployeeLayout/Pages/Header";
import Footer from "../../../Employee/EmployeeLayout/Pages/Footer";
import Cookies from "js-cookie";

const ConsultantLayout = () => {
  const [sidebarPinned, setSidebarPinned] = useState(
    Cookies.get("sidebarPinned") === "true",
  );
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  //  EXACT behavior you want
  const sidebarWidth = sidebarPinned || sidebarHovered ? "250px" : "70px";

  return (
    <div
      className="min-h-screen bg-gray-100"
      style={{ "--sidebar-width": sidebarWidth }}
    >
      <Sidebar
        isPinned={sidebarPinned}
        setIsPinned={setSidebarPinned}
        onHoverChange={setSidebarHovered}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
      />
      {/* MAIN AREA */}
      <div className="flex flex-col h-screen overflow-hidden transition-all duration-300 ml-0 md:ml-[var(--sidebar-width)]">
        <Header toggleSidebar={() => setIsMobileOpen(true)} />

        <main className="flex-1 overflow-y-auto"><Outlet /></main>

        <Footer />
      </div>
    </div>
  );
};

export default ConsultantLayout;
